import { render, staticRenderFns } from "./ViewPurchasesOrderPage.vue?vue&type=template&id=1387a58c"
import script from "./ViewPurchasesOrderPage.vue?vue&type=script&lang=js"
export * from "./ViewPurchasesOrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports